import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Entete from "./dataset/Entete";
import { ThemeContext } from "./ThemeContext";
import APIAdmin from "../Authentification/apiAdmin";
// import "../../Styles/AdminDashbord/imageCouverture.css";

const ImageCouverture = () => {
  const { theme } = useContext(ThemeContext);
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [link, setLink] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const loadImages = async () => {
    try {
      const res = await APIAdmin.get("/admin/cover-images");
      setImages(res.data.data || []);
    } catch (err) {
      console.error("Erreur fetch cover images:", err);
      toast.error("Impossible de charger les images");
    }
  };

  useEffect(() => {
    loadImages();
  }, []);

  const handleImageChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newErrors = {};

    if (!file) {
      toast.info("Sélectionne une image");
      setLoading(false);
      return;
    }

    if (!link.trim()) {
      newErrors.link = "Veuillez entrer le lien de redirection";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("image", file, file.name);
    formData.append("description", description);
    formData.append("link", link);

    try {
      await APIAdmin.post("/admin/cover-images", formData);

      toast.success("Image ajoutée");
      setFile(null);
      setDescription("");
      setLink("");
      loadImages();

      window.dispatchEvent(new Event("coverImagesUpdated"));
    } catch (err) {
      console.error(err.response?.data.message);
      toast.error("Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  const toggleActive = async (id) => {
    try {
      await APIAdmin.patch(`/admin/cover-images/${id}/toggle-active`);
      setImages((prev) =>
        prev.map((img) =>
          img.id === id ? { ...img, active: !img.active } : img,
        ),
      );
      window.dispatchEvent(new Event("coverImagesUpdated"));
    } catch (err) {
      console.error(err.response?.data);
      toast.error("Impossible de changer le statut");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette image ?")) return;
    try {
      await APIAdmin.delete(`/admin/cover-images/${id}`);
      setImages((prev) => prev.filter((i) => i.id !== id));

      toast.info("Supprimé");
      window.dispatchEvent(new Event("coverImagesUpdated"));
    } catch (err) {
      console.error(err.response?.data);
      toast.error("Impossible de supprimer");
    }
  };

  return (
    <div className="cover-image-page">
      <Entete title="Images de couverture" />

      <div
        className="col shadow-sm border border-1 p-3 mt-3"
        style={{ backgroundColor: theme === "dark" ? "black" : "white" }}
      >
        {/* LISTE */}
        <section>
          <h2 className="petit_titre">Liste des images</h2>
          <div className="table-responsive">
            <table className="table table-striped mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Description</th>
                  <th>Lien de redirection</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {images.length === 0 ? (
                  <tr>
                    <td colSpan="5">Aucune image</td>
                  </tr>
                ) : (
                  images.map((img) => (
                    <tr key={img.id}>
                      <td>{img.id}</td>
                      <td>
                        <img src={img.url} alt="" className="cover-thumb" style={{ width: 120 }} />
                      </td>
                      <td className="cover-description-cell">
                        <div>{img.description}</div>
                      </td>
                      <td className="cover-link-cell">
                        <div>{img.link}</div>
                      </td>
                      <td>
                        <div className="d-flex flex-column flex-sm-row gap-2">
                          <Button
                            size="sm"
                            variant={img.active ? "secondary" : "success"}
                            onClick={() => toggleActive(img.id)}
                          >
                            {img.active ? "Désactiver" : "Activer"}
                          </Button>

                          <Button
                            size="sm"
                            variant="danger"
                            onClick={() => handleDelete(img.id)}
                          >
                            Supprimer
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </section>

        {/* FORM */}
        <section className="mt-3">
          <h2 className="petit_titre">Ajouter une image</h2>

          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label className="label_register">Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImageChange}
              />
            </Form.Group>

            <Form.Group className="mt-2">
              <Form.Label className="label_register">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                className="input_register"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mt-2">
              <Form.Label className="label_register">Lien de redirection</Form.Label>
              <Form.Control
                type="text"
                className="input_register"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                isInvalid={!!errors?.link}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.link}
              </Form.Control.Feedback>
            </Form.Group>

            <Button className="mt-3 w-100" disabled={loading} type="submit">
              {loading ? "Envoi..." : "Enregistrer"}
            </Button>
          </Form>
        </section>
      </div>
    </div>
  );
};

export default ImageCouverture;